import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ActionCardConfigInterface, BrightsideUiModule } from '@brightside/brightside-ui';
import { BsChatService } from '@brightside-web/desktop/data-access/core-services';

@Component({
    selector: 'brightside-web-chat-action',
    templateUrl: './chat-action-card.component.html',
    styleUrl: './chat-action-card.component.scss',
    imports: [BrightsideUiModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChatActionCardComponent {
  private _bsChatService: BsChatService = inject(BsChatService);

  chatActionCardConfig: ActionCardConfigInterface = {
    label: 'CHAT_ACTION_LABEL',
    labelBold: true,
    labelIcon: 'actions',
    labelIconSize: 22,
    body: 'CHAT_ACTION_DESC',
    cardStyle: 'small',
    shadow: true,
    marginBottom: 'small',
  };

  showChatInterface() {
    this._bsChatService.showChat();
  }
}
